import type { JSX } from "react";
import { cn } from "./cn";

export interface LetterSeparatorProps {
  readonly letter: string;
  readonly className?: string;
}

export function LetterSeparator({ letter, className }: LetterSeparatorProps): JSX.Element {
  return (
    <div className={cn("flex items-center gap-3 py-3 px-4", className)}>
      <div className="flex-1 border-t border-edge" />
      <span className="text-xs font-semibold uppercase text-content-secondary">
        {letter}
      </span>
      <div className="flex-1 border-t border-edge" />
    </div>
  );
}
